module.exports = __webpack_public_path__ + "static/media/allisonrietta-IG-3.9e37bdad.PNG";